module.exports = __webpack_public_path__ + "static/img/navmenu-active.f0ff71c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/navmenu-active.png
// module id = 5u2z
// module chunks = 1